import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

export interface IDateModuleData {
    startOfWeekConfig: number;
    companyDate: string;
    datePattern: string;
}

@ModuleName("DateModule")
export class DateModule implements AxInit {
    private startOfWeekConfig: number;
    private companyDate: string;
    private datePattern: string;

    AxInit(init: IDateModuleData): void {
        this.startOfWeekConfig = init.startOfWeekConfig;
        this.companyDate = init.companyDate;
        this.datePattern = init.datePattern;
    }

    getStartOfWeekConfig(): number {
        return this.startOfWeekConfig;
    }

    getCompanyDate(): string {
        return this.companyDate;
    }

    getDatePattern(): string {
        return this.datePattern;
    }
}